import { render, staticRenderFns } from "./domesticInfo.vue?vue&type=template&id=20344393&"
import script from "./domesticInfo.vue?vue&type=script&lang=js&"
export * from "./domesticInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports